<template>
	<div>

		<breadcrumbs />
		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.transactions_limitations }}
							</h6>
							<div class="element-box">
								<transactionsForm />
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
			START - Sidebar
			-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">

					<h6 class="element-header">

					</h6>
					<div class="element-box-tp">

					</div>
				</div>
			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>
	</div>
</template>

<script>
    import transactionsForm from '@/components/accounting/form/limitationsForm'
    export default {
        name: 'transactionsLimitations',
	    components: {transactionsForm},
        data () {
            return {
                t: this.$root.t
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	h1, h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}
</style>



// WEBPACK FOOTER //
// src/components/accounting/transactionsLimitations.vue